/**
 * Amount types
 */
const AMOUNT_TYPES = {
  tax: 'tax',
  noTax: 'noTax',
};

export default AMOUNT_TYPES;
